<div style="width: 800px; height: 400px;">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;">
      <div class="section-header-title">Void Charge</div>
    </div>
    <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading"></app-tdo-progress-spinner>

    <!--  MAIN AREA-->
    <div class="section-content" *ngIf="!isLoading"
      style="flex: 1; display: flex; flex-direction: column; height: 100%;">
      <div *ngIf="!isLoading" style="flex: 1; overflow-y: hidden;">

        <div style="display: flex; flex-direction: row; padding: 10px 10px 10px 10px">
          <div style="flex-basis: 30%" class="input-container-height">
            <b>Total Amount</b><br>
            {{ itemToVoid?.Amount | currency }}
          </div>
          <div style="flex-basis: 70%" class="input-container-height">
            <b>Description</b><br>
            {{ itemToVoid?.Description }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column; padding: 10px 10px 10px 10px">
          <div class="input-container-height">
            <mat-form-field style="width:100%">
              <mat-label>Reason</mat-label>
              <input data-cy="adjustment-note" matInput autocomplete="off" [(ngModel)]="voidReason" required>
            </mat-form-field>
          </div>
          <div class="input-container-height validation-message"><br/>
            {{ validationResult?.Message }}
          </div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px;">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="close(null)" class="tdo-button tdo-close"
        style="margin-right: 10px; margin-top: 10px;">Cancel</button>
      <button *ngIf="validationResult?.IsValid" (click)="processVoid()" class="tdo-button tdo-save" [disabled]="voidReason===''"
        style="margin-right: 6px; margin-top: 10px;">Ok</button>
    </div>
  </div>
</div>